
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'ngMaterial',
    'ngMessages',
    'BlurAdmin.pages.inicio'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider, $httpProvider, baSidebarServiceProvider) {
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push(['$q', '$localStorage', '$location', '$rootScope', function ($q, $localStorage, $location, $rootScope) {
      var typeToken;
      $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        if (toState.data.permissions && toState.data.permissions[0]) {
          typeToken = toState.data.permissions[0];
        }
      });
      return {
        'request': function (config) {
          config.headers = config.headers || {};
          var token;

          switch (typeToken) {
            case "ADMIN":
              token = $localStorage.lvl0 ? $localStorage.lvl0.token : undefined;
              break;
            default:
              token = undefined;
          }

          if (token) {
            config.headers['X-AUTH-TOKEN'] = token;
          }
          return config;
        },
        'responseError': function (response) {
          if (response.status === 401 || response.status === 403) {
            switch (typeToken) {
              case "ADMIN":
                window.location.href = 'auth.html';
                break;
            }

          }
          return $q.reject(response);
        }
      };
    }]);

    $urlRouterProvider.otherwise('/inicio/dados');

  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.inicio', ['ngResource'])
        .config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('inicio', {
                url: '/inicio',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Inicio',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                data: {
                    requireLogin: true,
                    permissions: ['ADMIN']
                }
            })
            .state('inicio.dados', {
                url: '/dados',
                controller: 'inicioCtrl',
                controllerAs: 'iniCtrl',
                templateUrl: 'app/pages/inicio/inicio.html',
                title: 'Inicio'
            })

            .state('inicio.confirmacao', {
                url: '/confirmacao/:referencia',
                templateUrl: 'app/pages/inicio/confirmacao.html',
                title: 'Inicio',
                controllerAs: 'vm',
                controller: 'confirmacaoCtrl',

            })
        


    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

'use strict';

angular.module('BlurAdmin', [
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'ngStorage',
  'angular-md5',
  'ngMask',
  'ui.utils.masks',
  'BlurAdmin.theme',
  'BlurAdmin.pages',
  'Enderecos'
]);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }
  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')  
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $http, $location, $rootScope, baSidebarService) {


    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {

      angular.afterBindings(function () {
        $rootScope.$pageFinishedLoading = false;
      });

      $rootScope.$baSidebarService = baSidebarService;

    });

      $rootScope.location = $location;

    // Para funcionar angular.afterBindings
    angular._global = {
      $rootScope: $rootScope,
      $http: $http,
      $timeout: $timeout
    };

  }


})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.inicio')
        .controller('confirmacaoCtrl', ['$stateParams',  confirmacaoCtrl]);

    /** @ngInject */
    function confirmacaoCtrl($stateParams) {

        var vm = this;
        vm.referencia = $stateParams.referencia;
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inicio')
    .controller('inicioCtrl', ['Inicio','$rootScope', '$state', 'ModuloEmpresa', '$timeout', 'GoogleAdWordsService', '$mdToast', inicioCtrl]);

  /** @ngInject */
  function inicioCtrl(Inicio, $rootScope, $state, ModuloEmpresa, $timeout, GoogleAdWordsService, $mdToast) {

    var vm = this;

    vm.consultaCnpj = _consultaCnpj;
    vm.salvarEmpresa = _salvarEmpresa;
    vm.referencia = _referencia;
    vm.validarEmail = _validarEmail;
    vm.exibeOcultaSenha = _exibeOcultaSenha;
    vm.dadosCarregados = false;
    vm.type = 'password';
    vm.icon = "assets/img/theme/icon/eye-on.svg";

    vm.pessoal = {};
    vm.empresa = {};

    function _exibeOcultaSenha() {
      vm.type = vm.type === 'password' ? 'text' : 'password';
      vm.icon = vm.type === 'password' ? "assets/img/theme/icon/eye-on.svg" : "assets/img/theme/icon/eye-off.svg"
    }

    function _referencia(text) {
      if (!text) {
        text = '';
      }
      vm.referencias = [];
      if (text.length > 4) {
        vm.refUtilizada = false;
        vm.referenciaEnviada = text.replace(/ /g, '').toLowerCase();
        Inicio.referencia({
            referencia: vm.referenciaEnviada.substring(0, 20)
          },
          function (response) {
            vm.referencias = response.sugestoes;
            if (vm.referencias) {
              vm.pessoal.referencia = '';
              vm.refUtilizada = true;
            } else {
              vm.pessoal.referencia = vm.referenciaEnviada.substring(0, 20);
            }

          });
      }
    }

    function _consultaCnpj(cnpj) {
      Inicio.getCnpj({
          cnpj: cnpj
        },

        function (data) {
          vm.empresa = data;
          vm.dadosCarregados = true;
        },
        function (response) {
          vm.dadosCarregados = false;
          vm.empresa = {};
          toastr.warning(response.data, "Busca CNPJ");
        }
      );
    }

    function _salvarEmpresa() {

      if (vm.form.$invalid) {
        $mdToast.show(
          $mdToast.simple()
          .textContent('Dados inválidos, favor verificar os campos em vermelho!', 'error')
          .position('top right')
          .hideDelay(3000)
        );

        return;
      };

      $rootScope.$pageFinishedLoading= true;
      ModuloEmpresa.save(vm,
        function (response) {
          GoogleAdWordsService.sendRegisterCustomerConversion();
          $state.go('inicio.confirmacao', {referencia: response.data.referencia});
          $rootScope.$pageFinishedLoading= false;
        },
        function (response) {
          var erros = response.data.errors.map(function (e) {
            $rootScope.$pageFinishedLoading= false;
            return e.descricao;
          });

          $mdToast.show(
            $mdToast.simple()
            .textContent(erros)
            .position('top right')
            .hideDelay(3000)
          );
        });

    };

    function _validarEmail(email) {
      vm.emailValido = undefined;
      vm.pessoal.mensagemEmail = '';

      if (email) {

        $timeout(function () {

          if (vm.emailValido === undefined) {
            vm.emailValido = true;
          }

        }, 5000)

        Inicio.validEmail({
            email: email
          },
          function (response) {
            vm.emailValido = response.data.emailValido;
            vm.pessoal.mensagemEmail = response.data.mensagem;
            vm.form.email.$setValidity('validEmail', response.data.emailValido);
          });
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.inicio')
    .factory('Inicio', Inicio)
    .factory('ModuloEmpresa', ModuloEmpresa);

  Inicio.$inject = ['$resource', 'API_URL_EMPRESA'];
  ModuloEmpresa.$inject = ['$resource', 'API_URL_EMPRESA'];

  function Inicio($resource, API_URL_EMPRESA) {
    var base = API_URL_EMPRESA + "empresa/pessoa",
      cnpj = base.concat("/cnpj/:cnpj"),
      referencia = base.concat('/referencia/'),
      email = base.concat('/valida/');

    return $resource(base, { cnpj: '@cnpj', referencia: '@referencia', email: '@email' }, {
      'getCnpj': {
        url: cnpj,
        method: 'GET',
        transformResponse: function (data, headersGetter, status) {
          data = angular.fromJson(data);
          var empresa = {};
          if ([200, 201].indexOf(status) > -1) {
            empresa = data.data;

            return empresa;
          } else {
            return "Não foi possível encontrar CNPJ";
          }
        }
      },
      'referencia': {
        url: referencia,
        method: 'GET',
        transformResponse: function (data, headersGetter, status) {
          data = angular.fromJson(data);

          if ([200, 201].indexOf(status) > -1) {
            return data.data;
          }
          return data;

        }
      },
      'validEmail': {
        url: email,
        method: 'GET'
      }
    });
  }



  function ModuloEmpresa($resource, API_URL_EMPRESA) {
    var base = API_URL_EMPRESA.concat("empresa/pessoa"),
      resourceUrl = base + "/:id";

    return $resource(resourceUrl, {}, {
      'get': { method: 'GET' },
      'save': {
        headers: {'X-SERVICE': 'AZUL_CONTROLE'},
        method: 'POST',
        transformRequest: function (data) {
          var dadosCadastro = {
            nome: data.pessoal.nome,
            email: data.pessoal.email,
            telefone: data.pessoal.telefone,
            senha: data.pessoal.senha,
            cnpj: data.empresa.cnpj,
            referencia: data.pessoal.referencia,
            razaoSocial: data.empresa.razaoSocial
          }

          return angular.toJson(dadosCadastro);
        }
      },
      'update': { headers: {'X-SERVICE': 'AZUL_CONTROLE'}, method: 'PUT' }
    })
  }
}());

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig() {
    toastr.options = {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 10000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      preventOpenDuplicates: true,
      showEasing: "swing",
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
      hideEasing: 'linear'
    };
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('compareTo', compareTo);
  compareTo.$inject = [];
  /** @ngInject */
  function compareTo() {
    return {
      require: "ngModel",
      scope: {
        compareTolValue: "=compareTo"
      },
      link: function (scope, element, attrs, ngModel) {
        console.log(ngModel)
        console.log(scope)
        ngModel.$validators.compareTo = function(modelValue) {

          return modelValue == scope.compareTolValue;
        };

        scope.$watch("compareTolValue", function() {
          ngModel.$validate();
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('searchWatchModel', searchModel);



    function searchModel() {

        return {
            require: '^stTable',
            scope: {
                searchWatchModel: '='
            },
            link: function (scope, ele, attr, ctrl) {
                var table = ctrl;

                scope.$watch('searchWatchModel', function (val) {
                    ctrl.search(val);
                });

            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        $timeout(function(){
          var input = $(elem).find('input');
          input.bootstrapSwitch({
            size: 'small',
            onColor: attr.color
          });
          input.on('switchChange.bootstrapSwitch', function(event, state) {
            scope.ngModel = state;
            scope.$apply();
          });

        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated fadeIn');
        }, delay);
      }
    };
  }

})();
angular.module('BlurAdmin.theme')
  .factory('GoogleAdWordsService', function ($window) {
    // Conversion labels 
    var google_conversion_label = {
      'register-customer': "12abCDef3gH5Klm6789",
      'book-order': "9876mlK5Hg3feDCba21"
    };
    // Basic settings for AdWords Conversion
    var googleTrackConversion = function (conversion_label) {
      $window.google_trackConversion({
        google_conversion_id: 849371833,
        google_conversion_label: "MQoeCKy6k34QucWBlQM",
        google_remarketing_only: false
      });
    };

    return {
      sendRegisterCustomerConversion: function () {
        // Trigger register-customer conversion 
        googleTrackConversion('register-customer');
      },
      sendBookOrderConversion: function () {
        // Trigger book-order conversion 
        googleTrackConversion('book-order');
      }
    };
  });
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var min = 0;
        var opened = false;
        var changeMax = false, 
            changeMin = true;

        return {
            setProgress: function (value) {
                if (value > max || changeMax)  {
                    changeMax = true;
                    changeMin = false;
                    progress -= 10;
                }
                if (progress < min || changeMin) {
                    changeMin = true;
                    changeMax = false;
                    progress = value;
                }

            },
            getProgress: function () {
                return progress;
            },
            open: function () {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/cadastros/template/progressModal.html',
                        controller: 'ProgressModalCtrl',
                        controllerAs: 'proCtrl',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function () {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            },
            isOpen: function(){
                return opened;
            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal, $state) {
        var vm = this;

        vm.fechar = _fechar;




        function _fechar() {
            baProgressModal.close();
            $state.go('cadastros.emissaoNota');
        }
        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 200) {

            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('userService', userService);

  /** @ngInject */
  function userService($q, $localStorage, md5) {
    var nivel = '';
        
    return {
      getUsersAccess: function() {
        return this.nivel;
      },

      getValidAccess: function(roles) {
        var perm = false;
        var level = null;
        angular.forEach(roles, function(role, key) {

            switch(role) {
                case "ADMIN":
                    level =  $localStorage.lvl0 ? $localStorage.lvl0.level : null;
                    break;
                default:
                    level = null;
            }  

            if (md5.createHash(role || '') === level) {
                perm = true;    
            }
        });
        return perm;
      },

      setUserAccessAdmin: function() {
        this.nivel = 'ADMIN';
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function () {
  angular.afterBindingsQueue = [];
  angular.afterBindings = function (callback, initialWait) {
    var CHECK_TICK = 100,
      watchersCount = -1,
      $http = angular._global.$http,
      $timeout = angular._global.$timeout,
      $rootScope = angular._global.$rootScope;

    angular.afterBindingsQueue.push(callback);

    function waitOnInit() {
      var initEnds = true;

      //check for new watchers
      initEnds = initEnds && ($rootScope.$$watchersCount == watchersCount);
      watchersCount = $rootScope.$$watchersCount;

      //check for pending requests
      initEnds = initEnds && $http.pendingRequests.length == 0;

      if (initEnds) {
        //execute first callback from queue
        $timeout(function () {
          angular.afterBindingsQueue.shift()();
        });
      } else {
        setTimeout(function () {
          waitOnInit();
        }, CHECK_TICK);
      }

    }

    if (typeof initialWait != 'undefined' && initialWait > 0) {
      setTimeout(function () {
        waitOnInit();
      }, initialWait);
    } else {
      waitOnInit();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function (tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1);
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl: 'app/theme/components/baWizard/baWizardStep.html',
      link: function ($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          nome: $attrs.nome,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      bindToController: true
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('loader', loader);

    /** @ngInject */
    function loader() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/loader/loader.html'
        };
    }

})();
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/inicio/confirmacao.html","<div class=\"login-page\" layout=\"column\"><md-content><div class=\"confirmacao-formulario\" layout=\"column\"><div class=\"img-steps\"><img src=\"assets/img/theme/azulctrlogo.png\"></div><div class=\"card\"><div class=\"mensagens\" layout=\"column\"><span class=\"title negrito\">Uhuuuu!</span> <span class=\"title\">O seu cadastro está completo, aproveite agora mesmo o teste gratuito por 3 dias.</span> <span class=\"title\" style=\"margin-top:20px;\">Favor verificar seu email para completar a ativação do cadastro.</span><md-button class=\"botao\" href=\"https://azulctr.com.br/{{vm.referencia}}\" type=\"button\">Acessar plataforma</md-button></div></div></div><div class=\"login-right\" layout=\"column\"><div class=\"login-image\"><img src=\"assets/img/theme/confirmacao.png\"></div><div layout=\"column\"><div class=\"confirm-footer\"><img src=\"assets/img/theme/footer-logo.svg\"></div><div class=\"informacao\"><span><a href=\"https://azulcontrole.com.br\">Site oficial</a></span> <span>Política de privacidade</span> <span>Termo de uso</span> <span>Central de ajuda</span></div></div></div></md-content></div>");
$templateCache.put("app/pages/inicio/inicio.html","<div class=\"login-page\" layout=\"column\"><md-content><div class=\"login-formulario\" layout=\"column\"><div class=\"img-steps\"><img src=\"assets/img/theme/azulctrlogo.png\"></div><div class=\"card\"><form name=\"iniCtrl.form\" class=\"form-login\" ng-submit=\"iniCtrl.salvarEmpresa($baWizardController)\"><div class=\"dados\"><label>Nome</label><md-input-container class=\"input-login\" layout=\"column\"><input type=\"text\" name=\"nome\" ng-model=\"iniCtrl.pessoal.nome\" required=\"\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"iniCtrl.referencia(iniCtrl.pessoal.nome)\"></md-input-container><label>Telefone</label><md-input-container class=\"input-login\" layout=\"column\"><input type=\"text\" name=\"telefone\" ng-model=\"iniCtrl.pessoal.telefone\" required=\"\" ui-br-phone-number=\"\"><div ng-messages=\"iniCtrl.form.telefone.$error\"><div ng-message=\"brPhoneNumber\">Telefone inválido.</div></div></md-input-container><label>Email</label><md-input-container class=\"input-login\" layout=\"column\"><input type=\"email\" name=\"email\" ng-model=\"iniCtrl.pessoal.email\" class=\"valid\" required=\"\" ng-blur=\"iniCtrl.validarEmail(iniCtrl.pessoal.email)\"><div class=\"hint green\" ng-show=\"iniCtrl.pessoal.emailValido == true\">{{iniCtrl.pessoal.mensagemEmail}}</div><div class=\"hint red\" ng-show=\"iniCtrl.pessoal.emailValido == false\">{{iniCtrl.pessoal.mensagemEmail}}</div><div ng-messages=\"iniCtrl.form.email.$error\"><div ng-message=\"validEmail\">{{iniCtrl.pessoal.mensagemEmail}}</div></div></md-input-container><label>Senha de Acesso</label><div layout=\"row\"><md-input-container class=\"input-login\" flex=\"100\"><input type=\"{{iniCtrl.type}}\" name=\"senha\" ng-model=\"iniCtrl.pessoal.senha\" required=\"\" minlength=\"5\"><div ng-messages=\"iniCtrl.form.senha.$error\"><div ng-message=\"minlength\">Mínimo de 5 caracteres.</div></div></md-input-container><div class=\"eye\"><ng-button ng-click=\"iniCtrl.exibeOcultaSenha()\"><md-icon md-svg-src=\"{{iniCtrl.icon}}\" class=\"name\"></md-icon></ng-button></div></div><label>Repetir Senha</label><md-input-container class=\"input-login\" layout=\"column\"><input type=\"password\" compare-to=\"iniCtrl.pessoal.senha\" name=\"senhaConfirmacao\" ng-model=\"iniCtrl.pessoal.senhaConfirmacao\" required=\"\"><div ng-messages=\"iniCtrl.form.senhaConfirmacao.$error\" role=\"alert\"><div ng-message=\"compareTo\">As senhas devem ser iguais</div></div></md-input-container><label>Acesso</label><md-input-container class=\"input-login\" layout=\"column\"><input type=\"text\" name=\"referencia\" minlength=\"4\" ng-model=\"iniCtrl.pessoal.referencia\" required=\"\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"iniCtrl.referencia(iniCtrl.pessoal.referencia)\"><div ng-messages=\"iniCtrl.form.referencia.$error\" ng-if=\"iniCtrl.refUtilizada\"><div ng-message=\"required\">Referência \"{{iniCtrl.referenciaEnviada}}\" já utilizada, favor informar outra.</div><div ng-message=\"maxlength\">Tamanho máximo 20 caracteres</div><div ng-message=\"minlength\">Tamanho minimo 4 caracteres</div></div></md-input-container><div class=\"color-white\">Esta informação será utilizada para acessar o sistema posteriormente</div><div class=\"color-white\">Ex: www.azulctr.com.br/ <span class=\"color-yellow hint\">{{iniCtrl.pessoal.referencia ? iniCtrl.pessoal.referencia: \"NomeDeAcesso\"}}</span></div><ul class=\"margin-bottom-20\" ng-show=\"iniCtrl.referencias.length > 0\"><p class=\"color-white\">Sujestões de referências:</p><div class=\"sujestao\" layout=\"row\" ng-repeat=\"ref in iniCtrl.referencias\"><a href=\"\" ng-click=\"iniCtrl.pessoal.referencia = ref; iniCtrl.referencias = []\">{{ref}}</a></div></ul><ul class=\"margin-top-10\"><p class=\"color-white\" nopadding=\"\"><input type=\"checkbox\" ng-model=\"aceite\" aria-label=\"Toggle ngShow\"> Eu li e concordo com os <a style=\"cursor: pointer;\" ng-click=\"checked=true\">termos de uso</a></p><br><input type=\"hidden\" ng-model=\"checked\"><div ng-show=\"checked\" style=\"color: #222222;position:absolute; background-color:#AAAAAA;z-index:20001; top:10%; left:50%;margin-left:-40%\" ng-click=\"checked=false\">Fechar</div><div ng-show=\"checked\" style=\"color: #222222;position:absolute; background-color:#EEF3F7; top:10%; left:50%;margin-left:-40%;margin-right:-40%;height: 80%; width: 80%; z-index:20000;padding-top:20px;padding-left:50px;padding-right:20px;padding-bottom:20px; overflow: scroll;border-style: solid; border-width: 1px;border-color:#3949ab;\">Bem-vindo á Azul Controle<br><br>ESTE É O ACORDO LEGAL ENTRE VOCÊ E A AZUL CONTROLE, E REGE O SEU USO DO PRODUTO E SERVIÇOS DISPONIBILIZADOS PELA AZUL CONTROLE (COLETIVAMENTE DENOMINADO “SERVIÇO”). É IMPORTANTE QUE VOCÊ LEIA E ENTENDA OS TERMOS A SEGUIR. CLICANDO EM “ACEITO”, VOCÊ CONCORDA QUE ESTES TERMOS SERÃO APLICÁVEIS SE OPTAR POR ACESSAR OU UTILIZAR O SERVIÇO.<br><br>Através do endereço eletrônico http://www.azulctr.com.br (“Site”), a AZUL CONTROLE irá disponibilizar aos seus usuários, autorização não exclusiva, intransferível e revogável do uso do sistema AZUL CONTROLE, o qual tem como objetivo oferecer uma plataforma que auxilie no cadastro de produtos e serviços, expedição de notas de saída, e nota fiscal eletrônica.<br><br>O sistema AZUL CONTROLE poderá ser contratado de qualquer parte do mundo, porém ressaltamos que, ao adquiri-los, você estará concordando com esses termos e condições de uso (“Termo de Uso”) e sujeito a Legislação Brasileira, bem como ao cumprimento integral do seguinte termos:<br><br>I. Condições Gerais.<br><br>Poderá usar o Software os maiores de 18 (dezoito) anos, residentes e domiciliados no Brasil ou Exterior e que possuam plena capacidade civil, conforme art. 5º da Lei nº 10.406/02. Desse modo, informações de pessoas com idade inferior a 18 (dezoito) anos não poderão ser submetidas ao site para cadastro e habilitação do sistema AZUL CONTROLE.<br><br>Para obtenção e utilização do software, o usuário, pessoa física ou jurídica, deverá fornecer voluntariamente em seu cadastro as respectivas informações solicitadas no Site. Destacamos, ainda, que outros dados importantes para a contratação poderão ser requeridos, sendo que o usuário se responsabiliza civil e criminalmente, inclusive perante terceiros, pela veracidade dos dados informados.<br><br>A AZUL CONTROLE tem o direito de suspender ou cancelar o acesso de qualquer usuário nos casos de suspeita de fraude, participação através da obtenção de benefício ou vantagem de forma ilícita ou pelo não cumprimento de quaisquer das condições deste Termo de Uso e da Política de Privacidade. Nos casos referidos neste parágrafo, a AZUL CONTROLE não deverá qualquer indenização ao usuário e poderá ingressar com a ação cabível a fim de resguardar seus interesses.<br><br>II. Dispositivos e Contas.<br><br>A utilização do Serviço pode requerer dispositivos compatíveis, acesso à Internet, e determinado software (poderão ser aplicáveis taxas); poderão ser exigidas atualizações periódicas; e poderá ser afetado pelo desempenho destes fatores. A última versão do software poderá ser exigida para a realização de determinadas operações ou utilização de certas funcionalidades. Você concorda que o cumprimento desses requisitos é de responsabilidade sua.<br><br>III. Limitações relativas à Utilização.<br><br>Você concorda em utilizar o Serviço apenas para as finalidades permitidas por este Acordo e somente na medida permitida por qualquer lei aplicável, regulamento ou prática aceita na jurisdição aplicável. Os serviços adicionais estão disponíveis para compra, conforme descrito no momento da contratação.<br><br>IV. Disponibilidade do Serviço.<br><br>O Serviço, ou qualquer característica ou parte do mesmo, pode não estar disponível em todas as línguas ou em todos os países e a AZUL CONTROLE não faz qualquer declaração de que o Serviço, ou qualquer característica ou parte do mesmo, é apropriado ou disponível para utilização em qualquer lugar em particular. Na medida em que escolher aceitar e utilizar o Serviço, estará fazendo por iniciativa própria e será responsável pelo cumprimento de quaisquer leis aplicáveis.<br><br>V. Alteração do Serviço.<br><br>A AZUL CONTROLE reserva-se o direito de, a qualquer momento, modificar este Acordo e impor termos e condições novos ou adicionais relativamente à utilização do Serviço. Tais modificações e termos e condições adicionais serão comunicados a você e, se aceitos, se tornarão vigentes imediatamente e serão incorporados a este Acordo. Caso você recuse a aceitação de tais alterações, a AZUL CONTROLE se reserva no direito de cancelar este Acordo e a sua conta. Você concorda que a AZUL CONTROLE não será responsável perante si ou qualquer terceiro por qualquer modificação ou cessação do Serviço. Se você pagou para usar o Serviço e nós o cancelarmos ou reduzirmos materialmente sua funcionalidade, nós lhe forneceremos um reembolso rateado de qualquer pré-pagamento.<br><br>VI. Funcionalidades do Software<br><br>O Sistema AZUL CONTROLE viabiliza e vem oferecer uma plataforma que auxilie no cadastro de produtos e serviços, expedição de notas de saída, e nota fiscal eletrônica.<br><br>Para ter acesso ao Sistema, o usuário precisará se cadastrar no site http://www.azulctr.com.br e criar um USUÁRIO e SENHA. O USUÁRIO e SENHA darão acesso à página pessoal do usuário, onde esse irá escolher o plano que deseja e lhe beneficia. Após contratar o plano, o usuário, na mesma página pessoal do Site, terá acesso ao plano de serviços contratados e poderá utilizá-lo de acordo com suas necessidades, desde que em conformidade com este Termo e Políticas.<br><br>Esclarecemos que para o adequado funcionamento do Software, o usuário necessitará configurar os produtos e os seus respectivos dados. Ademais, é de suma importância o usuário ter conhecimento de que as informações lançadas no Sistema são de sua exclusiva responsabilidade, estando, portanto, a AZUL CONTROLE isenta de qualquer problema decorrente de mal-uso.<br><br>A AZUL CONTROLE reserva-se no direito de, sem aviso prévio, atualizar, modificar, adaptar ou alterar o Sistema e sua interface com os usuários, sempre que julgar que tais modificações possam resultar no aperfeiçoamento técnico. Desse modo, é dever do usuário da AZUL CONTROLE manter o Sistema sempre atualizado, ficando a AZUL CONTROLE isenta de qualquer problema que decorra da falta de atualização.<br><br>Em caso de força maior, a AZUL CONTROLE poderá interromper o funcionamento do Sistema a qualquer momento, sendo que nesse caso não será devida qualquer indenização aos usuários. O usuário que tenha problemas com a utilização ou apresente dificuldade para utilizar o programa, deverá entrar em contato com o suporte da AZUL CONTROLE. A partir da formalização da comunicação, a AZUL CONTROLE trabalhará para solucionar a situação ou esclarecer a dúvida do usuário.<br><br>Ressaltamos que a utilização do Sistema está vinculada ao pagamento da mensalidade relativo ao plano escolhido.<br><br>VII. CONTRATAÇÃO ELETRÔNICA<br><br>A utilização do Serviço inclui a capacidade de celebrar acordos e/ou efetuar transações eletronicamente. VOCÊ RECONHECE QUE SEUS ENVIOS ELETRÔNICOS CONSTITUEM SEU ACORDO E SUA INTENÇÃO DE CONTRATAR OS SERVIÇOS, BEM COMO DE PAGAR PELAS OPERAÇÕES E TRANSAÇÕES REALIZADAS. O SEU ACEITE E INTENÇÃO DE ESTAR VINCULADO E OS ENVIOS ELETRÔNICOS APLICAM-SE A TODOS OS REGISTROS RELATIVOS A TODAS AS TRANSAÇÕES DE QUE VOCÊ PARTICIPAR RELATIVAS A ESTE SERVIÇO, INCLUINDO AVISOS DE CANCELAMENTO, POLÍTICAS, CONTRATOS E APLICAÇÕES. Para acessar e guardar os seus registros eletrônicos poderá ser requerido que você possua determinado hardware e/ou software, o que será de sua exclusiva responsabilidade.<br><br>VIII. DO PAGAMENTO<br><br>Os Serviços disponibilizados pela AZUL CONTROLE são do tipo RECORRENTE, configurando, assim, uma relação de trato sucessivo, a qual se renova mensalmente mediante o pagamento do respectivo preço, de modo que o usuário pagará antecipadamente a prestação referente ao próximo mês de uso, sendo, portanto, um serviço pré-pago.<br><br>O pagamento do plano escolhido será debitado mensalmente e automaticamente, no cartão de crédito que deverá ser informado no momento do cadastro do usuário.<br><br>Os valores referentes ao plano serão reajustados todo dia 1º de janeiro, de acordo com o INPC/IBGE ou, na sua ausência, com o índice que vier a substituí-lo, independentemente de prévia notificação ao usuário.<br><br>Caso não ocorra o pagamento no prazo aqui previsto, a prestação dos serviços será SUSPENSA e a AZUL CONTROLE se reserva no direito de restringir o seu acesso ao conteúdo armazenado em sua conta até que seja regularizada as pendências e ocorra o restabelecimento do serviço.<br><br>O pagamento posterior à SUSPENSÃO acarreta o restabelecimento dos Serviços em até 24 h (vinte e quatro horas) a contar do recebimento do comprovante de pagamento pela AZUL CONTROLE, sem qualquer efeito retroativo referente ao período em que os Serviços e a utilização da ferramenta restaram suspensos.<br><br>A partir da SUSPENSÃO, o usuário tem o prazo máximo de 90 (noventa) dias para regularização de sua conta, sendo-lhe disponibilizada neste período a possibilidade de restabelecimento dos serviços sem perda de quaisquer dados do cadastro.<br><br>Caso não ocorra o pagamento no prazo previsto no item anterior, a prestação dos serviços SERÁ CANCELADA.<br><br>Havendo o CANCELAMENTO, após o período de 90 (noventa) dias de inatividade, os dados da conta como notas fiscais emitidas, clientes, produtos, históricos e os demais dados serão excluídos dos arquivos da AZUL CONTROLE não podendo mais ser resgatados, ainda que através de medidas judiciais.<br><br>O pagamento do débito posterior ao CANCELAMENTO não implica na renovação automática do(s) Serviço(s). Caso seja de interesse do usuário, será necessária a realização de nova contratação, sujeitando-se o usuário a valores que estiverem vigentes por ocasião desta nova contratação, sem qualquer efeito retroativo referente ao período em que os Serviços restaram suspensos, entre o cancelamento e a nova contratação.<br><br>Tais medidas se operarão sem prejuízo da adoção das medidas judiciais e extrajudiciais cabíveis para a cobrança dos valores em atraso.<br><br>IX. PRAZO E RESCISÃO<br><br>Este Termo será renovado automaticamente por períodos iguais e sucessivos de 1(um) mês, sendo que poderá ser rescindido nas seguintes hipóteses:<br><br>a) a qualquer tempo, em caso de infração ou inadimplência às suas cláusulas e condições, independentemente de interpelação judicial ou extrajudicial, assim como em caso de pedido de recuperação judicial, extrajudicial e/ou falência de qualquer uma das partes, ou ainda, falecimento da parte contratante em caso de pessoa física.<br><br>b) por interesse de qualquer das partes, a qualquer tempo, mediante aviso formal à outra com 30 (trinta) dias de antecedência, por escrito. Na hipótese de rescisão antecipada requerida pelo usuário. Para os planos com pagamento mensal, caso o usuário decida rescindir os serviços antes do término do prazo regular do Termo de Uso, a AZUL CONTROLE não restituirá ao usuário o saldo restante do plano contratado. Este valor será retido pela AZUL CONTROLE para cobrir os custos operacionais.<br><br>X. A SUA UTILIZAÇÃO DO SERVIÇO<br><br>a. A sua Conta<br><br>Como utilizador registrado do Serviço, você deverá efetuar a criação de uma Conta. Não revele a sua informação de Conta a mais ninguém. Você será exclusivamente responsável por manter a confidencialidade e segurança da sua Conta e por todas as atividades que ocorrem dentro ou através da sua Conta, e concorda em notificar imediatamente a AZUL CONTROLE de qualquer falha de segurança na sua Conta. Você ainda reconhece e concorda que o Serviço foi designado e dirigido ao uso individual e que você não deve compartilhar os detalhes de sua Conta e/ou senha com outras pessoas que não sejam seus prepostos. Desde que tenha exercido perícia cabível e cuidado devido, a AZUL CONTROLE não será responsável por quaisquer perdas resultantes da utilização não autorizada da sua Conta em consequência de não seguir estas regras.<br><br>De modo a utilizar o Serviço, você deverá digitar seu USUÁRIO e SENHA para autenticar a sua Conta. Você concorda em disponibilizar informações corretas e completas quando se registrar, e conforme utilizar o Serviço, em atualizar os seus Dados de Registro do Serviço de modo a mantê-los precisos e completos. A não disponibilização de Dados de Registro de Serviço corretos, atuais e completos poderão resultar na suspensão e/ou encerramento da sua Conta. Você concorda que a AZUL CONTROLE poderá armazenar e utilizar os Dados de Registro do Serviço que o usuário disponibiliza para utilização na manutenção e cobrança dos planos em sua Conta.<br><br>b. Não Existência de Direito de Sucessão<br><br>A menos que exigido por lei, você concorda que a sua Conta e que quaisquer direitos a seu LOGIN e o conteúdo dentro da sua Conta não são passíveis de transferência e terminarão com a sua morte. Após o recebimento de cópia de uma certidão de óbito a sua Conta poderá ser encerrada e todo o Conteúdo dentro da mesma será apagado.<br><br>c. Não Revenda do Serviço<br><br>Você concorda que não irá reproduzir, copiar, duplicar, vender, revender, alugar ou comercializar o Serviço (ou qualquer parte do mesmo) para qualquer finalidade.<br><br>d. Informações Fiscais<br><br>A AZUL CONTROLE fornece único e exclusivamente o sistema de cadastro de produtos e serviços, expedição de notas de saída, e nota fiscal eletrônica e armazenamento dos documentos na constância do contrato, não constando em nossas obrigações dar assistência ou qualquer tipo de informação no que se tratar de área contábil ou fiscal. Caso o cliente tenha a necessidade de qualquer informação nesse sentido, ele deverá contatar um profissional habilitado nesta área.<br><br>XI. Da Responsabilidade de Informações Fiscais<br><br>A AZUL CONTROLE em hipótese alguma fornece informações fiscais para emissão de nota fiscal eletrônica, tais como alíquota, impostos e afins, ficando essa responsabilidade por parte do cliente ou de qualquer profissional contábil de confiança do mesmo.<br><br>XII. Remoção de Conteúdo<br><br>Você reconhece que a AZUL CONTROLE não é responsável ou imputável de qualquer modo por qualquer Conteúdo disponibilizado por outros e não tem qualquer dever de efetuar uma pré-verificação de tal Conteúdo. Contudo, a AZUL CONTROLE reserva-se o direito de a todo o tempo determinar se o Conteúdo é apropriado e está em conformidade com o Acordo, podendo efetuar uma pré-verificação, mover, recusar, modificar e/ou remover Conteúdo a qualquer momento, sem pré-aviso e a seu exclusivo critério, se determinar que tal Conteúdo viola de alguma maneira este Acordo ou é de outro modo censurável.<br><br>XIII. Acesso à Sua Conta e Conteúdo<br><br>A AZUL CONTROLE reserva-se no direito de tomar medidas que a AZUL CONTROLE acredita serem razoavelmente necessárias ou apropriadas para aplicação e/ou verificar a conformidade com qualquer parte deste Acordo. Você reconhece e concorda que a AZUL CONTROLE pode, sem responsabilidade para com o usuário, acessar, utilizar, preservar e/ou divulgar a sua informação de Conta e Conteúdo às autoridades de aplicação da lei, oficiais do governo, e/ou a terceiros, conforme a AZUL CONTROLE acredite ser razoavelmente necessário ou apropriado, se lhe for legalmente exigido efetuá-lo ou se acreditarmos de boa fé que tal acesso, utilização, divulgação, ou preservação é razoavelmente necessário para: (a) cumprir com processo ou pedido legal; (b) fazer valer este Acordo, incluindo a investigação de qualquer potencial violação do mesmo; (c) detectar, prevenir ou de outro modo fazer em face de questões de segurança, fraude ou técnicas; ou (d) proteger os direitos, propriedade ou segurança da AZUL CONTROLE, seus utilizadores, um terceiro, ou o público conforme exigido ou permitido por lei.<br><br>XIV. Cessação pela AZUL CONTROLE<br><br>A AZUL CONTROLE poderá a qualquer momento, sob determinadas circunstâncias e sem aviso prévio, cessar ou suspender de imediato toda ou uma parte da sua Conta e/ou acesso ao Serviço. O motivo para tal cessação incluirá: (a) violações deste Acordo ou quaisquer outras políticas ou diretrizes que aqui estejam referenciadas e/ou publicadas no Serviço; (b) um pedido do Usuário para cancelar ou cessar a sua Conta; (c) um pedido e/ou ordem de entidades de aplicação da lei, entidade judicial, ou outra agência governamental; (d) onde a prestação do Serviço ao Usuário seja ou possa tornar-se ilegal; (e) questões ou problemas técnicos ou de segurança não esperados; (f) a sua participação em atividades fraudulentas ou ilegais; ou (g) falha no pagamento de quaisquer quantias devidas pelo usuário em relação ao Serviço. Quaisquer dessas cessações ou suspensões serão efetuadas pela AZUL CONTROLE a seu critério exclusivo e a AZUL CONTROLE não será responsável perante o Usuário ou qualquer terceiro por quaisquer danos que possam resultar ou surgir dessa cessação ou suspensão da sua Conta e/ou acesso ao Serviço. Qualquer desses cancelamentos ou suspensões serão efetuados pela AZUL CONTROLE a seu critério exclusivo e a AZUL CONTROLE não será responsável perante o usuário ou qualquer terceiro por quaisquer danos que possam resultar ou derivar de tal cancelamento ou suspensão da sua Conta e/ou acesso ao Serviço, embora reembolso pro rata quaisquer taxas ou montantes pagos adiantadamente.<br><br>XV. Acordo Integral<br><br>Este Acordo constitui o acordo integral entre você e a AZUL CONTROLE, regendo a utilização dos Serviços, prevalecendo sobre quaisquer acordos prévios em relação a Serviços. Você também poderá estar sujeito a termos e condições adicionais que são aplicáveis quando utiliza serviços relacionados, conteúdo ou software de terceiros. Se qualquer parte deste Acordo for considerada inválida ou insuscetível de exigência legal, esta será interpretada de modo consistente com a lei aplicável de modo a refletir, tanto quanto possível, as intenções originais das partes, e as disposições restantes permanecerão totalmente exigíveis e em vigor. A não exigência de cumprimento, por parte da AZUL CONTROLE, de quaisquer direitos ou disposições contidas neste Acordo, não constituirá uma renúncia a tal direito. Você concorda que, exceto pelo previsto neste Acordo, não existirão quaisquer terceiros beneficiários com relação a este documento.<br><br>XVI. Limitação de Responsabilidade<br><br>A AZUL CONTROLE não presta quaisquer Serviços referentes à assessoria de negócios, sem limitação a outros, sendo, portanto, exclusivamente uma ferramenta de comunicação e auxílio dos negócios. Por esse motivo, a AZUL CONTROLE não se responsabiliza ou garante qualquer resultado nas relações comerciais do usuário.<br><br>A AZUL CONTROLE não se responsabiliza, por conseguinte, pela existência ou legitimidade dos dados cadastrados pelo usuário no Site e em suas diversas ferramentas, assim como pela capacidade para contratar do usuário ou pela veracidade dos dados pessoais em seu cadastro, sendo que estes dados são inseridos pelo usuário por sua própria conta e risco.<br><br>A AZUL CONTROLE não se responsabiliza por qualquer dano, prejuízo ou perda ocasionada no equipamento do usuário por falhas na internet, no sistema ou no servidor utilizado pelo usuário, seja decorrente de condutas de terceiros, caso fortuito ou força maior. A AZUL CONTROLE também não se responsabiliza por qualquer vírus que possa atacar o equipamento do usuário em decorrência do acesso, utilização ou navegação na internet ou como consequência da transferência de dados, arquivos, imagens ou textos.<br><br>O usuário não poderá atribuir a AZUL CONTROLE qualquer responsabilidade, tampouco exigir o pagamento por lucro cessante em virtude de prejuízos resultantes de dificuldades técnicas ou falhas nos sistemas ou na internet. Eventualmente, o sistema poderá não estar disponível por motivos técnicos ou falhas da internet, ou por qualquer outro evento fortuito ou de força maior alheio ao controle da AZUL CONTROLE.<br><br>É de responsabilidade do usuário:<br><br>(I) manter o ambiente de seus computadores e demais dispositivos de acesso ao Site e ao Software seguros, valendo-se de ferramentas específicas para tanto, tais como antivírus, firewall, entre outras, de modo a contribuir para a prevenção de riscos eletrônicos;<br><br>(II) utilizar sistemas operacionais e navegadores atualizados e eficientes para a plena utilização do sistema, de acordo com as especificações fornecidas pela AZUL CONTROLE;<br><br>(III) equipar-se e responsabilizar-se pelos computadores e dispositivos de hardware necessários para o acesso ao Site, bem como pelo acesso desses computadores e dispositivos à Internet;<br><br>(IV) o uso, a guarda, a manutenção e o sigilo de todas as senhas e usuário que lhe forem cedidos para acesso ao Site e ao Software, garantindo à AZUL CONTROLE que não compartilhará as senhas com quaisquer terceiros, exceto seus empregados autorizados, que as utilizarão somente em seu benefício e nos termos aqui previstos.<br><br>XVII. Propriedade Intelectual<br><br>Todos os direitos relativos ao Site, à marca AZUL CONTROLE, ao Software e suas funcionalidades são de propriedade exclusiva da AZUL CONTROLE, inclusive no que diz respeito aos seus textos, imagens, layouts, base de dados, códigos de programação, linguagens informáticas, bases de dados e demais conteúdos criados direta ou indiretamente pela AZUL CONTROLE, sendo que estes direitos estão protegidos pelas leis e tratados internacionais de direito autoral, marcas, patentes, modelos e desenhos industriais.<br><br>O uso indevido e a reprodução total ou parcial dos referidos direitos de propriedade intelectual são proibidos, salvo quando autorizados expressamente pela AZUL CONTROLE.<br><br>O usuário se compromete a não ceder, sublicenciar, vender, doar, alienar, alugar ou transferir, total ou parcialmente, sob quaisquer modalidades, a qualquer título, o Software, assim como seus manuais, guias, procedimentos ou quaisquer outros documentos a eles relacionados. Compromete-se, ainda, a não efetuar engenharia reversa, não revelar, não duplicar, não copiar, não reproduzir, não autorizar e/ou permitir o uso e/ou acesso do Software por terceiros.<br><br>Nada neste Termo de Uso deverá ser interpretado como restrição a qualquer direito da AZUL CONTROLE sobre o Sistema, inclusive, sem limitação, no que se refere a seu direito de, a todo e qualquer tempo, desenvolver, modificar, explorar comercialmente e licenciar, a quaisquer terceiros e sob qualquer modalidade, o Sistema.<br><br>A constatação de qualquer violação a estas regras de propriedade intelectual sujeitará o usuário às penalidades previstas na Lei e, ainda, na suspensão ou no cancelamento dos Serviços e da utilização do Sistema.<br><br>XVIII. Proteção de Dados<br><br>É de responsabilidade da AZUL CONTROLE proteger e conservar todos os dados pessoais e senhas dos usuários, de modo que as informações fornecidas estarão sujeitas a medidas de segurança para impedir o acesso, o uso e a divulgação não autorizada.<br><br>A AZUL CONTROLE se compromete em manter as defesas administrativas, físicas e técnicas adequadas para proteger a segurança, confidencialidade e integridade dos dados do usuário, assim como a não (i) divulgar os dados do usuário, exceto se exigido pela lei, e (ii) acessar os dados disponibilizados exceto para prestar os Serviços, suporte ou resolver problemas de serviço ou técnicos, ou a pedido do usuário em relação aos aspectos de suporte ao cliente.<br><br>XIX. Confidencialidade<br><br>Cada parte se compromete a manter e tratar como confidencial e não revelar a terceiros qualquer Informação Confidencial relacionada aos Serviços, dados de usuários, segredo de indústria e outros, ou usar referidas informações para qualquer propósito que não aquele previsto no presente Termo.<br><br>Tanto as partes quanto os seus representantes legais, diretores, empregados, agentes e consultores, incluindo advogados, auditores e consultores financeiros, estão sujeitos ao dever de sigilo e confidencialidade previsto neste Termo.<br><br>Não obstante o disposto neste Termo, as Informações Confidenciais poderão ser reveladas nas seguintes hipóteses: (i) exigência legal aplicável, (ii) ordem ou decisão judicial ou em processo administrativo ou arbitral, ou (iii) solicitação de qualquer autoridade ou órgão regulador do Brasil. Em quaisquer das situações previstas nesta cláusula, a parte que tiver de divulgar as Informações Confidenciais somente o fará até a extensão exigida por tal ordem administrativa, arbitral ou judicial, e previamente orientada pela opinião de seus assessores legais, comprometendo-se a tomar todas as medidas razoavelmente necessárias para preservar a confidencialidade das Informações Confidenciais, incluindo a obtenção de uma medida protetiva ou outro provimento que possa assegurar a concessão de tratamento confidencial às Informações Confidenciais.<br><br>As partes reconhecem que qualquer quebra das obrigações de confidencialidade deste Termo pode causar danos à outra parte em valor não prontamente mensurável. Sendo assim, as partes acordam, sem prejuízo a outros direitos ou medidas cabíveis, que a parte infratora deverá reparar a parte reveladora dos danos efetivamente sofridos por esta.<br><br>A obrigação de confidencialidade aqui prevista permanecerá vigente enquanto perdurar o caráter de confidencialidade das informações recebidas.<br><br>XII - Disposições Finais<br><br>a. A AZUL CONTROLE reserva-se ao direito de alterar as condições deste Termo de Uso a qualquer momento, informando previamente os usuários.<br><br>b. Autorização: O usuário expressamente aceita que a AZUL CONTROLE envie aos seus assinantes mensagens de e-mail de caráter informativo, referentes a comunicações específicas sobre os Serviços prestados sob este Termo.<br><br>c. Novação: A tolerância da AZUL CONTROLE em exigir o estrito cumprimento das condições deste Termo de Uso, não constitui, em hipótese alguma, novação ou renúncia, nem impede que a AZUL CONTROLE exerça esses direitos a qualquer tempo.<br><br>d. Subsistência: Todas as disposições deste Termo que prevejam a observância de obrigações ou responsabilidades após a rescisão ou extinção deste Termo e/ou dos Serviços, subsistirão a sua rescisão ou extinção e continuarão em pleno vigor e efeito, em especial no que tange à propriedade intelectual, confidencialidade e privacidade de dados e informações.<br><br>e. Independência das partes: Este Termo não estabelece qualquer relação de mandato, sociedade e/ou associação, vínculo empregatício, agenciamento, representação, consórcio, joint venture ou responsabilidade solidária entre a AZUL CONTROLE e o usuário, que são pessoas jurídicas independentes e autônomas para todos os fins de direito, tampouco confere poderes a uma das partes para a representação da outra em quaisquer negócios jurídicos. A relação aqui estipulada entre a AZUL CONTROLE e o usuário partes é válida exclusivamente para o objeto e efeitos deste Termo.<br><br>f. Cláusulas independentes: Se alguma cláusula deste Termo for considerada ilegal, nula ou incapaz de ser cumprida por qualquer motivo, esta previsão será considerada uma cláusula independente da parte remanescente deste Contrato e não afetará a validade ou a aplicabilidade do cumprimento dos termos do restante do presente.<br><br>g. Responsabilidade: Cada Parte será responsável individualmente pelos atos que praticar, não sendo admitida solidariedade ou subsidiariedade presumidas.<br><br>h. Lei aplicável e foro: Todos os itens deste Termo de Uso estão regidos pelas leis vigentes na República Federativa do Brasil. Para todos os assuntos referentes à sua interpretação e cumprimento, as partes se submeterão o foro da Circunscrição Judiciária de Maringá, Paraná, exceção feita a reclamações apresentadas por usuários que se enquadrem no conceito legal de consumidores, que poderão submeter ao foro de seu domicílio.<br><br>Este Contrato considerar-se-á celebrado e obrigatório entre a AZUL CONTROLE e o usuário no momento em que o usuário concluir o seu cadastro e o procedimento previsto no Site, sendo certo que, assim procedendo, o usuário declara ter lido e compreendido todos os termos e condições deste Termo, razão pela qual é recomendável que o usuário imprima uma cópia deste documento para futura referência.<br><br>Última atualização: 13 de Dezembro de 2018.<br><br><br><br></div></ul><md-button class=\"botao\" type=\"submit\" ng-disabled=\"!aceite\">Criar conta</md-button></div></form><div class=\"duvidas\"><span>Dúvidas? Fale com nossa Central de Vendas (44) 99179-3895 ou (44) 99895-0049</span></div></div></div><div class=\"login-right\" layout=\"column\"><div class=\"login-image\"><img src=\"assets/img/theme/mensagem.svg\"> <img style=\"margin-top:30px\" src=\"assets/img/theme/imagem.svg\"></div><div layout=\"column\"><div class=\"login-footer\"><img src=\"assets/img/theme/footer-logo.svg\"></div><div class=\"informacao\"><span><a href=\"https://azulcontrole.com.br\">Site oficial</a></span> <span>Política de privacidade</span> <span>Termo de uso</span> <span>Central de ajuda</span></div></div></div></md-content></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\"><div class=\"indicador\" layout=\"column\" layout-align=\"center center\"><div class=\"stoped-number\" layout=\"row\" layout-align=\"center\"><span ng-hide=\"$baWizardController.tabNum > $index\">{{$index + 1}}</span><md-icon font-color=\"white\" ng-show=\"$baWizardController.tabNum > $index\">done</md-icon></div><span class=\"title\">{{t.nome}}</span></div></div></div><div class=\"steps\" ng-transclude=\"\"></div></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/loader/loader.html","<div class=\"loader\"><div class=\"logo-loader\"><img class=\"animated fadeIn infinite\" src=\"assets/img/loader.png\"></div><span class=\"loader--ball loader--ball__first\"></span> <span class=\"loader--ball\"></span> <span class=\"loader--ball\"></span> <span class=\"loader--ball\"></span></div>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<nav class=\"navbar navbar-default\" ng-if=\"location.path() !== \'/inicio/dados\'\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><img src=\"assets/img/logo.png\"></a></div><div id=\"navbar\" class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a href=\"#\"><i class=\"fa fa-home fa-fw\"></i> Principal</a></li><li class=\"dropdown\"><a style=\"cursor:pointer\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-fw fa-pencil-square\"></i> Cadastros <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#/cadastros/pessoa\">Clientes</a></li><li><a href=\"#/cadastros/produto\">Produtos</a></li><li><a href=\"#/cadastros/documentoSaida\">Documentos de Saída</a></li></ul></li><li class=\"active\"><a href=\"#/cadastros/emissao-nota\"><i class=\"fa fa-fw fa-file-text\"></i> Emitir nota</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li class=\"dropdown\"><a style=\"cursor:pointer\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-cog fa-fw\"></i> Minha conta <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a href=\"#\">Meus dados</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"#/cadastros/empresa\">Dados da Empresa</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"#/cadastros/planos\">Meus Planos</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"#\">Sair</a></li></ul></li></ul></div></div></nav>");}]);